import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68ACE } from './mg68_ace'

export class Mg68ACE_W extends Mg68ACE {
  name: string = 'MG68_ACE_W'
  icon: string = list_icon
  width: number = 710
  sleepTimeValues = [0, 30, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 4 * 60 * 60, 8 * 60 * 60, 12 * 60 * 60, 18 * 60 * 60]
  sleepTimeBTValues = this.sleepTimeValues
}
